module.exports = __webpack_public_path__ + "static/media/switch.f75268e1.svg";